import { useState } from "react";
import { Helmet } from "react-helmet-async";
import ReactHeader from "./reactHeader";
import FooterSection from "./footerSection";
import AnimatedBlock from "./animatedBlock";
import "./install.css"

const InstallSection = () => {
    const [agreed, setAgreed] = useState(false);
    const [downloaded, setDownloaded] = useState(false);

    const handleDownloadClick = (e) => {
        if (!agreed) {
            e.preventDefault();
            return;
        }
        setDownloaded(true);
    };

    if (downloaded) {
        return (
            <section className="page-section section-style section-style-contact install-success-section">
                <AnimatedBlock>
                    <div className="install-success-content">
                        <div className="install-success-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <polyline points="9 12 11 14 15 10" />
                            </svg>
                        </div>
                        <h1 className="install-success-heading">Download Successful</h1>
                        <p className="install-success-body">
                            Follow the steps below to get started.
                        </p>

                        <div className="install-step-list">
                            <div className="install-step-card">
                                <div className="install-step-number">1</div>
                                <div className="install-step-text">
                                    <h2 className="install-step-heading">Install Khor Developer</h2>
                                    <p className="install-step-body">
                                        Close all instances of Microsoft Excel, and install Khor Developer.
                                        <br />
                                        <span className="install-step-aside">
                                            Trust Warning?{" "}
                                            <a
                                                href="/trusting-the-download"
                                                className="installation-link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                See here
                                            </a>
                                        </span>
                                    </p>
                                </div>
                            </div>

                            <div className="install-step-card">
                                <div className="install-step-number">2</div>
                                <div className="install-step-text">
                                    <h2 className="install-step-heading">Reopen Excel</h2>
                                    <p className="install-step-body">
                                        Open any Excel workbook and Khor Developer will appear in the ribbon.
                                    </p>
                                </div>
                            </div>

                            <div className="install-step-card">
                                <div className="install-step-number">3</div>
                                <div className="install-step-text">
                                    <h2 className="install-step-heading">Launch Khor Developer</h2>
                                    <p className="install-step-body">
                                        Click <em>Launch Khor Developer</em> to log in and begin using our platform.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p className="install-support-note">
                            Questions or running into an issue? <a href="/contact" className="installation-link">Contact our support team</a> and we'll help you get set up.
                        </p>
                    </div>
                </AnimatedBlock>
            </section>
        );
    }

    return (
        <section className="page-section section-style section-style-contact">
            <AnimatedBlock>
            <div className="installation-container">
                <h1 className="installation-header">Installation</h1>
                <label className="install-agree-label">
                    <input
                        type="checkbox"
                        className="install-agree-checkbox"
                        checked={agreed}
                        onChange={e => setAgreed(e.target.checked)}
                    />
                    <span>I have read and agree to <a href="/subscription-agreement" className="installation-link">Khor's Master Services and Subscription Agreement</a></span>
                </label>
                <a
                    href={agreed ? "https://khordeveloperinstaller.blob.core.windows.net/khordeveloperaddin/KhorDeveloperSetup.exe" : undefined}
                    className={`btn btn--contact install-download-btn ${!agreed ? "install-download-btn--disabled" : ""}`}
                    download={agreed ? true : undefined}
                    onClick={handleDownloadClick}
                    aria-disabled={!agreed}
                >
                    Download
                </a>
            </div>
            </AnimatedBlock>
        </section>
    );
}

const Install = () => (
    <div className="App">
        <Helmet>
            <title>Download Khor Developer | Excel CRE Underwriting Software</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="Download and install Khor Developer — the Excel-native commercial real estate underwriting platform built for institutional investment professionals." />
            <meta property="og:title" content="Download Khor Developer | Excel CRE Underwriting Software" />
            <meta property="og:url" content="https://www.khordeveloper.com/install" />
            <link rel="canonical" href="https://www.khordeveloper.com/install" />
        </Helmet>
        <ReactHeader />
        <InstallSection />
        <FooterSection />
    </div>
);

export default Install;